export const PLAN_ALIGNMENT_DEFAULT_VALUES = {
  offsetX: 0,
  offsetY: 0,
  scale: 1,
  rotation: 0,
} as const;
